const ERR_MSG = {
  CANNOT_SERVE: '요청을 처리할 수 없습니다.',
  NETWORK: '네트워크 환경을 확인해주세요.',
  RETRY: '잠시 후 다시 시도해주세요.',
  REPORT: '문제가 반복될 경우 관리자에게 문의해주세요.',
  BAD_REQUEST: '잘못된 요청입니다.',
  BAD_INPUT: '빠뜨리거나 잘못된 입력이 없는지 다시 한 번 확인해보세요.',
  NOT_FOUND: '요청하신 내용을 찾을 수 없습니다.',
  UNKNOWN: '알 수 없는 에러가 발생하였습니다.',
};

export default ERR_MSG;
